<select-input
  [control]="control"
  [label]="label"
  [values]="countries"
  [enableSearch]="true"
  [isCountryField]="true"
  [maxSelections]="1"
  key="name"
  [valueName]="valueName"
  [icon]="icon"
  iconType="fill"
  (onSearch)="onSearch($event)"
  (valueChanged)="onValueChange()"
  [filteredData]="filteredValues"
  [placeholder]="placeholder"
  [iconType]="iconType"
  [clearAll]="clearButton"
  [id]="id"
  [required]="required"
  [autocomplete]="autocomplete"
  (onKeydown)="onKeydownEvent($event)"
  (onBlurValueChange)="onBlurEvent($event)"
></select-input>
